import apiClient, { setAuthToken } from './api.client';

const ensureAuth = () => {
  const tk = localStorage.getItem('token');
  if (tk) setAuthToken(tk);
};

const handleError = (err) => {
  if (err && err.response && err.response.status === 401) {
    const e = new Error('Unauthorized');
    e.status = 401;
    throw e;
  }
  throw err;
};

const MenuService = {
  getMenu: async (menuCode) => {
    try {
      ensureAuth();
      const res = await apiClient.get(`/r/${menuCode}/menu`);
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  createMenuItem: async (data) => {
    try {
      ensureAuth();
      const res = await apiClient.post('/menu/items', data);
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  updateMenuItem: async (id, data) => {
    try {
      ensureAuth();
      const res = await apiClient.patch(`/menu/items/${id}`, data);
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  deleteMenuItem: async (id) => {
    try {
      ensureAuth();
      const res = await apiClient.delete(`/menu/items/${id}`);
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },
  createMenuItemImage: async (itemId, data) => {
    try {
      ensureAuth();
      const res = await apiClient.post(`/menu/items/${itemId}/images`, data);
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  deleteMenuItemImage: async (itemId, imageId) => {
    try {
      ensureAuth();
      const res = await apiClient.delete(`/menu/items/${itemId}/images/${imageId}`);
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },
  addVariant: async (itemId, data) => {
    try {
      ensureAuth();
      const res = await apiClient.post(`/menu/items/${itemId}/variants`, data);
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  updateVariant: async (variantId, data) => {
    try {
      ensureAuth();
      const res = await apiClient.patch(`/menu/items/variants/${variantId}`, data);
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  deleteVariant: async (variantId) => {
    try {
      ensureAuth();
      const res = await apiClient.delete(`/menu/items/variants/${variantId}`);
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  addSize: async (itemId, data) => {
    try {
      ensureAuth();
      const res = await apiClient.post(`/menu/items/${itemId}/sizes`, data);
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  updateSize: async (sizeId, data) => {
    try {
      ensureAuth();
      const res = await apiClient.patch(`/menu/items/sizes/${sizeId}`, data);
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  deleteSize: async (sizeId) => {
    try {
      ensureAuth();
      const res = await apiClient.delete(`/menu/items/sizes/${sizeId}`);
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },
};

export default MenuService;
